import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { DaLinkModule } from '../da-link';
import { TeaserBoxComponent } from './teaser-box/teaser-box.component';
import { TeaserBoxesContainerComponent } from './teaser-boxes-container.component';
import { PipesModule } from '@draeger-academy/common';
import { CourseTeaserModule } from '../course-teaser/course-teaser.module';
import { DaProgressiveImageModule } from '../da-progressive-image';

@NgModule({
    declarations: [TeaserBoxesContainerComponent, TeaserBoxComponent],
    exports: [TeaserBoxesContainerComponent, TeaserBoxComponent],
    imports: [CommonModule, PipesModule, CourseTeaserModule, DaLinkModule, DaProgressiveImageModule, RouterModule, LocalizeRouterModule]
})
export class TeaserBoxContainerModule {}
